export default __webpack_public_path__ + "static/media/press_room_thumb_modal10.d860794c.jpg";